/**
 *  ・クラス名
 *    データエクスポート用モデル
 *  ・概要
 *    データエクスポート画面で使用するmodelファイル
 *  ・更新履歴
 *    2022/01/26 新規作成 小林
 */
import BaseModel from './baseModel';
import ServiceType from '@/models/data/serviceType';
import Customer from '@/models/data/customer';
import Company from '@/models/data/company';
import Employee from '@/models/data/employee';
import Commodity from '@/models/data/commodity';
import LeasingCompany from '@/models/data/leasingCompany';

export default class DataExportModel extends BaseModel {
  private serviceType = new ServiceType();
  private customer = new Customer();
  private company = new Company();
  private employee = new Employee();
  private commodity = new Commodity();
  private leasingCompany = new LeasingCompany();

  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  constructor() {
    super();
  }

  /**
   * 各種入力フォームで使用する各マスタ情報を取得
   * プロパティーに格納します
   * @param none
   * @returns void
   */
  public async getMasterData() {
    const mData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
    [
      mData['m_service_type'],
      mData['m_customer'],
      mData['m_company'],
      mData['m_employee'],
      mData['m_commodity'],
      mData['m_leasing_company']
    ] = await Promise.all([
      this.serviceType.getFormatData(),
      this.customer.getFormatData(),
      this.company.getFormatData(),
      this.employee.getFormatData(),
      this.commodity.getFormatData(),
      this.leasingCompany.getFormatData()
    ]);
    this.masterData = mData;
    return this.masterData;
  }

  /**
   * マスタ情報を取得します
   * @returns {array} - マスタ情報配列
   */
  public getMaster() {
    return this.masterData;
  }

  /**
   * 指定データストアのフィールド情報を取得します
   * @returns {array} - フィールド情報配列
   */
  public getField(appId: string, dId: string) {
    return this.getFieldsData(appId, dId).then(data => data);
  }
}
